import PropTypes from 'prop-types'
import Box from '@mui/material/Box'
import { ReactComponent as IconFacebook } from '../icons/Facebook.svg'
import { ReactComponent as IconTwitter } from '../icons/Twitter.svg'
import { ReactComponent as IconLinkedIn } from '../icons/LinkedIn.svg'
// import { ReactComponent as IconInstagram } from '../icons/Instagram.svg'
import { ReactComponent as IconEmail } from '../icons/Email.svg'
// import { ReactComponent as IconHyperlink } from '../icons/Hyperlink.svg'

const TYPES = {
  facebook: {
    icon: <IconFacebook />,
    href: (url, subject, body) => `https://www.facebook.com/sharer/sharer.php?u=${url}`,
  },
  twitter: {
    icon: <IconTwitter />,
    // href: (url, subject) => `https://twitter.com/share?url=${url}`,
    href: (url, subject, body) => `https://twitter.com/share?url=${url}&text=${subject}`,
  },
  linkedin: {
    icon: null,
    icon: <IconLinkedIn />,
    href: (url, subject, body) => `https://www.linkedin.com/shareArticle?mini=true&url=${url}`,
  },
  email: {
    icon: <IconEmail />,
    // href: (url, subject) => `mailto:?&body=${url}`,
    href: (url, subject, body) => `mailto:?subject=${subject}&body=${body}`,
  },
  // hyperlink: {
  //   icon: <IconHyperlink />,
  //   href: (url, subject) => '/',
  // },
}
//write a function that converts a string into a mailto body link (replace spaces with %20, etc)



const SocialButton = ({
  type,
  url = `https://guidingourgrowth.utah.gov/`,
  subject,
  body,
}) => {

  const convertedSubject = convertLinkText(subject)
  const convertedBody = convertLinkText(body)

  return (
    <a 
      href={TYPES[type].href(url, convertedSubject, convertedBody)}
      target="_blank"
    >
      <Box
        sx={theme => ({
          width: 40,
          height: 40,
          borderRadius: '8px',
          borderStyle: 'solid',
          borderWidth: '1px',
          borderColor: theme.palette.neutral.dark,
          cursor: 'pointer',
          display: 'inline-grid',
          placeItems: 'center',
          placeContent: 'center',
          backgroundColor: theme.palette.primary.lighter,
          transition: theme.transitions.create(['background-color']),
          '&:hover': {
            backgroundColor: theme.palette.primary.light,
          },
        })}
      >
        {TYPES[type].icon}
      </Box>
    </a>
  )
}

SocialButton.propTypes = {
  type: PropTypes.oneOf(Object.keys(TYPES)),
}

export default SocialButton


function convertLinkText(text) {
  const encodedText = encodeURIComponent(text)
  return encodedText.replace(/'/g, '%27').replace(/"/g, '%22').replace(/ /g, '%20')
}